
import { inject, Injectable, DOCUMENT } from '@angular/core';

const TAG_MAP: Readonly<Record<string, string>> = {
  p: 'p',
  strong: 'strong',
  b: 'strong',
  u: 'u',
  i: 'i',
  em: 'em',
  li: 'li',
  ul: 'ul',
  ol: 'ol',
};

const VOID_MAP: Readonly<Record<string, string>> = {
  br: 'br',
  hr: 'hr',
};

const HEADING_RE = /^h[1-6]$/;

@Injectable({
  providedIn: 'root'
})
export class HtmlToBbCodeParserService {

  private readonly document = inject(DOCUMENT);

  public parse(html: string | null | undefined): string {
    if (!html) {
      return '';
    }

    const container = this.document.createElement('div');
    container.innerHTML = html;
    return this.serializeChildren(container);
  }

  private serializeNode(node: Node): string {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent ?? '';
    }
    if (node.nodeType !== Node.ELEMENT_NODE) {
      return '';
    }

    const el = node as Element;
    const tag = el.tagName.toLowerCase();

    if (tag === 'a') {
      return this.parseLink(el);
    }

    const voidTag = VOID_MAP[tag];
    if (voidTag) {
      return `[${voidTag}]`;
    }

    if (HEADING_RE.test(tag)) {
      return `[${tag}]${this.serializeChildren(el)}[/${tag}]`;
    }

    const mapped = TAG_MAP[tag];
    if (mapped) {
      return `[${mapped}]${this.serializeChildren(el)}[/${mapped}]`;
    }

    return this.serializeChildren(el);
  }

  private serializeChildren(node: Node): string {
    let out = '';
    node.childNodes.forEach((child) => {
      out += this.serializeNode(child);
    });
    return out;
  }

  private parseLink(el: Element): string {
    const href = (el.getAttribute('href') ?? '').trim();
    const inner = this.serializeChildren(el);
    return href ? `[url]${href}|${inner}[/url]` : inner;
  }
}
